import {useState, FC} from 'react'
import {Modal} from 'jbc-front/components/presenters/ui/Modal'
import {ButtonRow} from 'jbc-front/components/presenters/layout/ButtonRow'
import Button from 'jbc-front/components/Button'
import {Balloon} from 'jbc-front/components/presenters/ui/Balloon'
import {Link as LinkIcon} from 'jbc-front/components/icons'
import styles from './SyncHrMasterModal.scss'
import {useMutation} from 'hooks/graphql'
import {
  START_SYNC_HR_MASTER,
  StartSyncHrMasterResult,
  OrganizationType,
  organizationTypeName,
  StartSyncHrMasterVariables,
} from '../query'

interface SyncHrMasterModalProps {
  disabled: boolean
  refetchLatestTask: () => void
  organizationType: OrganizationType
  disabledReason: string | null
}

export const SyncHrMasterModal: FC<SyncHrMasterModalProps> = ({
  disabled,
  refetchLatestTask,
  organizationType,
  disabledReason,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isBalloonOpen, setIsBalloonOpen] = useState<boolean>(false)

  const [syncGroups, {loading}] = useMutation<StartSyncHrMasterResult, StartSyncHrMasterVariables>(
    START_SYNC_HR_MASTER,
    {
      onCompleted: () => {
        refetchLatestTask()
        handleClose()
      },
    }
  )
  const handleToggleOpen = () => setIsBalloonOpen((prev) => !prev)
  const handleClose = () => setIsOpen(false)

  const handleSync = () => {
    syncGroups({
      variables: {
        input: {
          organizationType: organizationType,
        },
      },
    })
  }

  const onClickBalloon = () => {
    setIsOpen(true)
    setIsBalloonOpen(false)
  }

  const orgName = organizationTypeName(organizationType)

  return (
    <>
      <Balloon.Container onClose={() => setIsBalloonOpen(false)}>
        <Button
          widthAuto
          disabled={disabled}
          onClick={handleToggleOpen}
          icon={<LinkIcon size={17} />}
          disabledReason={disabledReason}
          className={styles.syncButton}
        >
          連携
          <span className={styles.triangle} />
        </Button>

        <Balloon isOpen={isBalloonOpen}>
          <Balloon.Item disabled={disabled} onClick={() => onClickBalloon()}>
            共通マスタから取得
          </Balloon.Item>
        </Balloon>
      </Balloon.Container>

      <Modal isOpen={isOpen} onClose={handleClose}>
        <Modal.Header onClose={handleClose}>共通マスタからの取得</Modal.Header>
        <Modal.Body>
          <strong>共通マスタに登録された{orgName}のデータを取得します。</strong>
          <br />
          {orgName}コードが一致しないものは新規追加し、
          <br />
          {orgName}コードが一致するものは、更新します。
          <br />
          上記以外は変更しませんので、データ取得後に画面上で確認してください。
        </Modal.Body>
        <Modal.Footer>
          <ButtonRow>
            <Button onClick={handleClose} disabled={loading}>
              キャンセル
            </Button>
            <Button primary onClick={handleSync} disabled={loading}>
              取得
            </Button>
          </ButtonRow>
        </Modal.Footer>
      </Modal>
    </>
  )
}
